<template>
  <div class="IndexContainer">
    <div class="pd20 box">
      <div class="user" @click="$router.push('/my')">
        <img :src="user.avatar"/>
        <span class="smallFont">&nbsp;你好！{{ desensitize.desensitizeChineseName(user.nickName) }}</span>
        <img style="width: 15px;height: 15px;" src="../assets/image/right_icon.png" />
      </div>
      <div class="centerBox">
        <img src="../assets/image/index_icon.png" />
        <div class="text">
          <span class="moreStyle">消防宣传</span>
          <span>便民服务平台</span>
        </div>
      </div>
      <div class="whatWeDo">
        <div class="moreAboutUs leftCenter">
          <div></div>
          <span>已有{{ receptionCnt }}名市民走进服务平台</span>
        </div>
        <div class="msg">守护杭城平安</div>
        <nut-row class="bothCenter" :gutter="16">
          <nut-col :span="12" class="leftIndexBox">
            <WhatWeDoItemNew :data="menus[0]" @click="goToView('/visit')"/>
          </nut-col>
          <nut-col :span="12" class="rightIndexBox">
            <WhatWeDoItemNew :data="menus[1]" @click="goToView('/train')"/>
          </nut-col>
        </nut-row>
        <div class="indexDivider"/>
        <nut-row class="bothCenter" :gutter="16">
          <nut-col :span="12" class="leftIndexBox">
            <WhatWeDoItemNew :data="menus[2]" @click="goToView('/drill')"/>
          </nut-col>
          <nut-col :span="12" class="rightIndexBox">
            <WhatWeDoItemNew :data="menus[3]" @click="goToView('/study')"/>
          </nut-col>
        </nut-row>
        <div class="indexDivider"/>
        <nut-row class="leftCenter" :gutter="16">
          <nut-col :span="12" class="leftIndexBox">
            <WhatWeDoItemNew :data="menus[4]" @click="goToView('/consult')"/>
          </nut-col>
            <!-- <nut-col :span="12" class="rightIndexBox">
              <WhatWeDoItemNew :data="menus[5]" @click="goToView('/consult')"/>
            </nut-col> -->
        </nut-row>
      </div>
    </div>
    <nut-row class="colFlex mt12 smallFont bothCenter" style="color: whitesmoke">
      <div class="colFlex bothCenter">
        <span>本服务由浙江政务服务网、</span>
        <span>杭州市消防救援支队提供</span>
      </div>
      <span>服务咨询热线:&nbsp;<span @click="call('0571-89580761')"
                                     style="color: whitesmoke">0571-89580761</span></span>
    </nut-row>
    <!--    <div style="position: fixed;right: 13%;top: 50%">-->
    <!--      <nut-popover v-model:visible="animationVisible" targetId="popid" location="left-start">-->
    <!--        <template #content>-->
    <!--          <div class="colFlex pd16 smallFont">-->
    <!--            <span>欢迎使用，杭州消防救援</span>-->
    <!--            <span>便民服务平台！</span>-->
    <!--          </div>-->
    <!--        </template>-->
    <!--      </nut-popover>-->
    <!--    </div>-->
    <!--    <div style="position: fixed;right: 0;top: 50%">-->
    <!--      <img v-show="!animationVisible" @click="playAnimation"-->
    <!--           src="https://cdn.waityou.online/212931e8-4594-ae26-add4-ef606229d44a.png" style="height: 150px"/>-->
    <!--      <img v-show="animationVisible" @click="animationVisible=false"-->
    <!--           id="popid"-->
    <!--           :src="`https://cdn.waityou.online/8c483617-149e-fe36-4ce9-57c6570bf584.png?v=${animationVersion}`"-->
    <!--           style="height: 150px"/>-->
    <!--    </div>-->
  </div>
</template>


<script>
import api from "@/api";
import WhatWeDoItemNew from "@/components/index/WhatWeDoItemNew"
import {Dialog} from "@nutui/nutui";
import desensitize from "../utils/desensitize";
import {callPhone} from "@/utils/zlbutil"
import zwlogger from "@/utils/zwlogger";

export default {
  name: "IndexView",
  computed: {
    desensitize() {
      return desensitize
    }
  },
  components: {WhatWeDoItemNew},
  data() {
    return {
      old: false,
      needAsk: false,
      receptionCnt: 0,
      animationVisible: false,
      animationVersion: 0,
      user: {},
      banners: [],
      scrollHeight: 0,
      menus: [
        {
          icon: require('../assets/image/icon_bg1.png'),
          bgColor: '#F3F9FF',
          title: '我要参观',
          subTitle: '亲手摸摸消防车',
        },
        {
          icon: require('../assets/image/icon_bg2.png'),
          bgColor: '#FFF6E9',
          title: '我要培训',
          subTitle: '我的安全我做主',
        },
        {
          icon: require('../assets/image/icon_bg3.png'),
          bgColor: '#EEFFF7',
          title: '我要演练',
          subTitle: '假如真的着火了',
        },
        {
          icon: require('../assets/image/icon_bg4.png'),
          bgColor: '#FFF4F0',
          title: '我要学习',
          subTitle: '学消防为自己',
        },
        {
          icon: require('../assets/image/icon_bg5.png'),
          bgColor: '#F3F9FF',
          title: '我要咨询',
          subTitle: '为民服务每一天',
        },
        {
          icon: require('../assets/image/icon_bg6.png'),
          bgColor: '#FFFBF2',
          title: '我要娱乐',
          subTitle: '消了个消',
        },
      ]
    }
  },
  methods: {
    call(p) {
      callPhone(p);
    },
    goToView(url) {
      if (this.needAsk) {
        Dialog({
          title: '知晓率问卷',
          content: '花您2分钟时间回答消防安全知晓率问卷。谢谢参与！',
          okText: '去回答',
          noCancelBtn: true,
          onCancel: () => {
          },
          onOk: () => {
            this.$router.push('/ask')
          }
        });
      } else {
        this.$router.push(url)
      }
    },
    playAnimation() {
      this.animationVisible = true;
      setTimeout(() => {
        this.animationVisible = false;
        this.animationVersion++;
      }, 4200)
    },
    xlgx() {
      window.location.href = 'https://xlgx.isafety365.com/index.php?s=/game/index/cocos';
    },
  },
  mounted() {
    this.old = 'old' == localStorage.getItem('font-mode');
    if (this.$store.state.accessToken) {
      api.getUserInfo().then(ret => {
        this.user = ret;
      }).catch(() => {});
      api.isNeedAskPaper().then(ret => {
        this.needAsk = ret;
      }).catch(() => {});
    }
    api.getReceptionCnt()
        .then(ret => {
          this.receptionCnt = ret;
        }).catch(() => {})
    zwlogger.sendPv('IndexView', '首页')
  }
}
</script>

<style scoped lang="scss">
.IndexContainer {
  //padding: 16px;
  // background: linear-gradient(to bottom, #FFF, #f5f6f8, #485A89);
  background-image: url('../assets/image/picture_bg.png');
  background-repeat: no-repeat;background-size: 100% 100%;
  min-height: 100vh;
  .centerBox{
    margin-top: 1vh;
    display: flex;
    justify-content: space-between;
    height: 21vh;
    align-items: start;
    img{
      width: 120px;
      height: 19vh;
    }
    .text{
      font-size: 27px;
      color: #fff;
      display: flex;
      flex-direction: column;
      height: 200px;
      white-space: nowrap;
      letter-spacing: 0.5px;
      font-weight: 600;
      text-align: center;
    }
    .moreStyle{
      font-size: 38px;
      font-family: 'Open-Sans';
      letter-spacing: 3px !important;
      margin-bottom: 3px;
      font-weight: 400;
    }
  }

  .whatWeDo {
    display: flex;
    background-color: white;
    flex-direction: column;
    border-radius: 16px;
    padding: 24px 16px 35px;
    .msg{
      font-size: $miniFontSize;
      color: #999999;
      padding: 4px 16px 16px 8px;
    }
    .tip {
      padding-bottom: 12px;
    }

    .indexDivider {
      height: 20px;
    }

    .leftIndexBox {
      display: flex;
    }

    .rightIndexBox {
      display: flex;
    }
  }

  .user {
    display: inline-flex;
    width: auto;
    height: 32px;
    background: linear-gradient(to bottom, #EEDEE3, #d0d0ea);

    color: #001734;
    border-radius: 16px;
    padding: 0 8px;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
      border-radius: 12px;
      box-shadow: 0px 2px 24px 0px rgba(222, 237, 255, 0.8);
    }
  }

  .moreAboutUs {
    width: 100%;
    div{
      width: 2px;
      height: 14px;
      background-color: #999999;
      border-radius: 50px;
    }
    span {
      font-size: $smallerFontSize;
      color: #999999;
      margin-left: 6px;
      font-weight: bold;
    }
  }
}
</style>